import angular from 'angular';
import uiRouter from 'angular-ui-router';
import certificatesComponent from './certificates.component';

let certificatesModule = angular.module('app.containers.certificates', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('certificates', {
      url: '/certificates',
      template: '<certificates></certificates>'
    });
})

.component('certificates', certificatesComponent);

export default certificatesModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/certificates/certificates.js
 **/